/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless secondary written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var CorpFinSecondaryNamesSectionView = require('../views/CorpFinSecondaryNamesSectionView');
var GetSecondaryNamesByRecord = require('../services/GetSecondaryNamesByRecord');

module.exports = {
  channel: 'cf',

  event: 'build:corp-fin-secondary-names-section-view',

  builder: function(recordId, recordCategoryId, isReadOnly) {
    return new PlaceholderView({
      viewPromise: buildCorpFinSecondaryNamesSectionView(recordId, recordCategoryId, isReadOnly)
    });
  }
};

function buildCorpFinSecondaryNamesSectionView(recordId, recordCategoryId, isReadOnly) {
  var deferred = $.Deferred();
  GetSecondaryNamesByRecord(recordId)
    .done(function(secondaryNames) {
      deferred.resolve(
        new CorpFinSecondaryNamesSectionView({
          collection: new PageableCollection(secondaryNames, { pageSize: 25 }),
          recordCategoryId: recordCategoryId,
          isReadOnly: isReadOnly
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
